import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'reactstrap';
import { Drawer } from 'site-modules/shared/components/drawer/drawer';
import { DrawerCloseButton } from 'site-modules/shared/components/drawer/drawer-close-button/drawer-close-button';
import { usePrevious } from 'client/site-modules/shared/hooks/use-previous';
import { VehicleSelectorAsync } from './vehicle-selector-async';

/**
 * Renders drawer with VehicleSelector component.
 */
export const VehicleSelectorDrawer = ({
  onToggle,
  onSave,
  isOpen,
  isMpgField = false,
  title = 'Select a car',
  subtitle = 'or enter a selling price directly',
  showVehicleSelectOnly = false,
  finalStepBtnText = {},
  showLatestYears = false,
  splitNewUsedYears = false,
  hideAdditionalField = false,
  hasStyle = true,
  trackingParent,
  pubStates,
}) => {
  const [isDrawerComponentLoaded, setIsDrawerComponentLoaded] = useState(() => !!isOpen);
  const prevIsOpen = usePrevious(isOpen);

  if (prevIsOpen !== isOpen) {
    if (isOpen) setIsDrawerComponentLoaded(true);
  }

  return (
    <Drawer
      side="right"
      classNames={{ drawerContent: 'px-0_5' }}
      data-tracking-parent={trackingParent}
      toggle={onToggle}
      isOpen={isOpen}
    >
      <DrawerCloseButton
        onClick={onToggle}
        className="mb-0 mb-md-2_5 d-block px-md-2 px-lg-3_5 text-end text-md-start"
        lgBtnClass="ps-0"
        smBtnClass="d-inline-block"
      />
      {isDrawerComponentLoaded && (
        <Container className="mx-0 px-0">
          <VehicleSelectorAsync
            onClose={onToggle}
            onSave={onSave}
            isMpgField={isMpgField}
            title={title}
            subtitle={subtitle}
            showVehicleSelectOnly={showVehicleSelectOnly}
            finalStepBtnText={finalStepBtnText}
            showLatestYears={showLatestYears}
            splitNewUsedYears={splitNewUsedYears}
            hideAdditionalField={hideAdditionalField}
            hasStyle={hasStyle}
            pubStates={pubStates}
          />
        </Container>
      )}
    </Drawer>
  );
};

VehicleSelectorDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  finalStepBtnText: PropTypes.shape({
    vehicle: PropTypes.string,
    price: PropTypes.string,
  }),
  isMpgField: PropTypes.bool,
  showVehicleSelectOnly: PropTypes.bool,
  showLatestYears: PropTypes.bool,
  splitNewUsedYears: PropTypes.bool,
  hideAdditionalField: PropTypes.bool,
  hasStyle: PropTypes.bool,
  trackingParent: PropTypes.string,
  pubStates: PropTypes.arrayOf(PropTypes.string),
};
